import React from 'react';
import './Shimmer.scss';

const Shimmer = ({ height = 50, style = {}, line = false }) => (
  <div className="od-shimmer-bg " style={{ height, borderRadius: line ? 10 : 0, ...style }}></div>
);

export default Shimmer;
